<form [formGroup]="formGroup()">
  <div class="card">
    <div class="card-header">
      {{ "general.statement" | translate }}
    </div>
    <div class="card-body">
      <label>{{
        "registrationWizard.investmentQualificationTest.investorStatementForm.selectIfTrue"
          | translate
      }}</label>
      <div class="row flex-between-center">
        <app-validated-checkbox
          [inputFormControl]="formGroup().controls.q1OwnsTransferableSecurities"
          inputFormControlName="q1OwnsTransferableSecurities"
          label="registrationWizard.investmentQualificationTest.investorStatementForm.q1OwnsTransferableSecurities"
        >
        </app-validated-checkbox>

        <app-validated-checkbox
          [inputFormControl]="
            formGroup().controls.q2OwnsCrowdfundingAssetsOrLoans
          "
          inputFormControlName="q2OwnsCrowdfundingAssetsOrLoans"
          label="registrationWizard.investmentQualificationTest.investorStatementForm.q2OwnsCrowdfundingAssetsOrLoans"
        >
        </app-validated-checkbox>

        <app-validated-checkbox
          [inputFormControl]="formGroup().controls.q3HasCrowdfundingInvestments"
          inputFormControlName="q3HasCrowdfundingInvestments"
          label="registrationWizard.investmentQualificationTest.investorStatementForm.q3HasCrowdfundingInvestments"
        >
        </app-validated-checkbox>

        <app-validated-checkbox
          [inputFormControl]="formGroup().controls.q4OwnsTransferableSecurities"
          inputFormControlName="q4OwnsTransferableSecurities"
          label="registrationWizard.investmentQualificationTest.investorStatementForm.q4OwnsTransferableSecurities"
        >
        </app-validated-checkbox>

        <app-validated-checkbox
          [inputFormControl]="formGroup().controls.myStatementsAboveAreAccurate"
          inputFormControlName="myStatementsAboveAreAccurate"
          label="general.validStatements"
        >
        </app-validated-checkbox>
      </div>
    </div>
  </div>
</form>
